const COMMON_THEME = {
  "--box-shadow": {
    light: "0px 2px 8px 0px rgba(17, 17, 17, 0.12)",
    dark: "0px 2px 8px 0px rgba(255, 255, 255, 0.12)",
  },
  "--sheet-shadow": {
    light:
      "0px 0px 4px 0px rgba(36, 41, 47, 0.16), 0px 0px 8px 0px rgba(36, 41, 47, 0.16)",
    dark: "0px 0px 4px 0px rgba(69, 76, 84, 0.80), 0px 0px 8px 0px rgba(69, 76, 84, 0.80)",
  },
  "--modal-background": { light: "#24292f40", dark: "#02030340" },
  "--loading-background": {
    light: "rgba(5, 5, 5, 0.20)",
    dark: "rgba(254, 254, 254, 0.20)",
  },
  "--dim-normal": {
    light: "rgba(246, 248, 250, 0.40)",
    dark: "rgba(27, 28, 29, 0.40)",
  },
  "--dim-strong": {
    light: "rgba(36, 41, 47, 0.40)",
    dark: "rgba(69, 76, 84, 0.40)",
  },
};

const SHADOW_THEME = {
  "--shadow-modal": {
    light:
      "0px 0px 8px 0px rgba(36, 41, 47, 0.04), 0px 0px 12px 0px rgba(36, 41, 47, 0.12)",
    dark: "0px 0px 8px 0px rgba(69, 76, 84, 0.12), 0px 0px 12px 0px rgba(69, 76, 84, 0.24)",
  },
  "--shadow-toolbar": {
    light:
      "0px 0px 8px 0px rgba(36, 41, 47, 0.04), 0px 0px 12px 0px rgba(36, 41, 47, 0.12)",
    dark: "0px 2px 2px 0px rgba(0, 0, 0, 0.02), 0px 2px 8px 0px rgba(0, 0, 0, 0.12)",
  },
  "--shadow-area": {
    light:
      "0px 2px 1px 0px rgba(36, 41, 47, 0.04), 0px 4px 6px 0px rgba(36, 41, 47, 0.10)",
    dark: "0px 2px 1px 0px rgba(69, 76, 84, 0.16), 0px 4px 6px 0px rgba(69, 76, 84, 0.40)",
  },
  "--modal-footer": {
    light: "0px -4px 8px 0px #24292F0F",
    dark: "0px -4px 8px 0px #24292F0F",
  },
};

const PALETTE_THEME = {
  "--normal": { light: "#fefefe", dark: "#070707" },
  "--strong": { light: "#070707", dark: "#fefefe" },
};

const PRIMARY_THEME = {
  "--pri-blue-0": { light: "#ddf4ff", dark: "#20314B" },
  "--pri-blue-1": { light: "#b6e3ff", dark: "#0A3069" },
  "--pri-blue-2": { light: "#80ccff", dark: "#033D8B" },
  "--pri-blue-3": { light: "#54aeff", dark: "#0550AE" },
  "--pri-blue-4": { light: "#218bff", dark: "#0969DA" },
  "--pri-blue-5": { light: "#0969da", dark: "#218BFF" },
  "--pri-blue-6": { light: "#0550ae", dark: "#54AEFF" },
  "--pri-blue-7": { light: "#033d8b", dark: "#80CCFF" },
  "--pri-blue-8": { light: "#0a3069", dark: "#B6E3FF" },
  "--pri-blue-9": { light: "#002155", dark: "#DDF4FF" },
};

const GRAYSCALE_BG_THEME = {
  "--bg-gray-normal": { light: "#fefefe", dark: "#232424" },
  "--bg-gray-0": { light: "#f6f8fa", dark: "#1B1C1D" },
  "--bg-gray-1": { light: "#eaeef2", dark: "#050505" },
  "--bg-gray-2": { light: "#d0d7de", dark: "#404245" },
  "--bg-gray-3": { light: "#afb8c1", dark: "#404245" },
  "--bg-gray-4": { light: "#8c959f", dark: "#71757A" },
  "--bg-gray-5": { light: "#6e7781", dark: "#464A53" },
  "--bg-gray-6": { light: "#57606a", dark: "#202427" },
  "--bg-gray-7": { light: "#424a53", dark: "#2D3139" },
  "--bg-gray-8": { light: "#32383f", dark: "#C7CCD1" },
  "--bg-gray-9": { light: "#24292f", dark: "#020303" },
  "--bg-gray-strong": { light: "#070707", dark: "#FEFEFE" },
};
const GRAYSCALE_TEXT_THEME = {
  "--text-gray-normal": { light: "#fefefe", dark: "#FAFAFA" },
  "--text-gray-0": { light: "#f6f8fa", dark: "#2E3338" },
  "--text-gray-1": { light: "#eaeef2", dark: "#868F98" },
  "--text-gray-2": { light: "#d0d7de", dark: "#ACB8C3" },
  "--text-gray-3": { light: "#afb8c1", dark: "#646668" },
  "--text-gray-4": { light: "#8c959f", dark: "#71757A" },
  "--text-gray-5": { light: "#6e7781", dark: "#848D9A" },
  "--text-gray-6": { light: "#57606a", dark: "#E8EAED" },
  "--text-gray-7": { light: "#424a53", dark: "#B0B7BF" },
  "--text-gray-8": { light: "#32383f", dark: "#C7CCD1" },
  "--text-gray-9": { light: "#24292f", dark: "#A2ACB9" },
  "--text-gray-strong": { light: "#070707", dark: "#FEFEFE" },
};

const SECONDARY_THEME = {
  "--sec-orange-0": { light: "#ffebdd", dark: "#552200" },
  "--sec-orange-1": { light: "#ffd3b6", dark: "#69300A" },
  "--sec-orange-2": { light: "#ffb380", dark: "#8B3903" },
  "--sec-orange-3": { light: "#ff9854", dark: "#AE4905" },
  "--sec-orange-4": { light: "#ff7a21", dark: "#DA5D09" },
  "--sec-orange-5": { light: "#da5d09", dark: "#FF7A21" },
  "--sec-orange-6": { light: "#ae4905", dark: "#FF9854" },
  "--sec-orange-7": { light: "#8b3903", dark: "#FFB380" },
  "--sec-orange-8": { light: "#69300a", dark: "#FFD3B6" },
  "--sec-orange-9": { light: "#552200", dark: "#FFEBDD" },
};

const SYSTEM_THEME = {
  "--sys-red-0": { light: "#ff7b7b", dark: "#FE8080" },
  "--sys-red-1": { light: "#ff2323", dark: "#FD4949" },
};

const ACCENT_THEME = {
  "--accent-sand": { light: "#dbbb8a", dark: "#dbbb8a" },
  "--accent-mango": { light: "#fbd446", dark: "#fbd446" },
  "--accent-yellow": { light: "#ffca0d", dark: "#ffca0d" },
  "--accent-mandarin": { light: "#fbb32d", dark: "#fbb32d" },
  "--accent-apricot": { light: "#f69976", dark: "#f69976" },
  "--accent-nudie": { light: "#C68883", dark: "#C68883" },
  "--accent-peach": { light: "#f2b8bd", dark: "#f2b8bd" },
  "--accent-red": { light: "#ff7b7b", dark: "#ff7b7b" },
  "--accent-pink": { light: "#e97699", dark: "#e97699" },
  "--accent-cherry": { light: "#882b65", dark: "#882b65" },
  "--accent-plum": { light: "#d878e7", dark: "#d878e7" },
  "--accent-violet": { light: "#9783e8", dark: "#9783e8" },
  "--accent-purple": { light: "#8656b3", dark: "#8656b3" },
  "--accent-mulberry": { light: "#534171", dark: "#534171" },
  "--accent-blue": { light: "#799cf0", dark: "#799cf0" },
  "--accent-skyblue": { light: "#59abf2", dark: "#59abf2" },
  "--accent-bluegreen": { light: "#43badb", dark: "#43badb" },
  "--accent-mint": { light: "#59c5be", dark: "#59c5be" },
  "--accent-fresh": { light: "#a9df8b", dark: "#a9df8b" },
  "--accent-lime": { light: "#abd20f", dark: "#abd20f" },
  "--accent-green": { light: "#2d9f83", dark: "#2d9f83" },
  "--accent-forest": { light: "#074b12", dark: "#074b12" },
  "--accent-navy": { light: "#477bb8", dark: "#477bb8" },
};

const INTERACTION_THEME = {
  "--hovered": { light: "#7989A53D", dark: "#B5C2E53D" },
  "--pressed-normal": { light: "#fefefe7a", dark: "#0007147A" },
  "--pressed-strong": { light: "#0007147A", dark: "#FEFEFE7A" },
};

export const UNIQUE_COLOR = {
  "--unique-1": { light: "#ff6f61", dark: "#ff6f61" },
  "--unique-2": { light: "#f8a92e", dark: "#f8a92e" },
  "--unique-3": { light: "#ff9f4b", dark: "#ff9f4b" },
  "--unique-4": { light: "#ffcd6b", dark: "#ffcd6b" },
  "--unique-5": { light: "#ff875f", dark: "#ff875f" },
  "--unique-6": { light: "#f5b538", dark: "#f5b538" },
  "--unique-7": { light: "#f6d03f", dark: "#f6d03f" },
  "--unique-8": { light: "#e8a63d", dark: "#e8a63d" },
  "--unique-9": { light: "#ffbe44", dark: "#ffbe44" },
  "--unique-10": { light: "#ff7b8b", dark: "#ff7b8b" },
  "--unique-11": { light: "#f98c8f", dark: "#f98c8f" },
  "--unique-12": { light: "#d97d92", dark: "#d97d92" },
  "--unique-13": { light: "#ff88e1", dark: "#ff88e1" },
  "--unique-14": { light: "#f57db9", dark: "#f57db9" },
  "--unique-15": { light: "#ff5e79", dark: "#ff5e79" },
  "--unique-16": { light: "#db6a98", dark: "#db6a98" },
  "--unique-17": { light: "#6f8eaf", dark: "#6f8eaf" },
  "--unique-18": { light: "#5fa7f4", dark: "#5fa7f4" },
  "--unique-19": { light: "#57c0dd", dark: "#57c0dd" },
  "--unique-20": { light: "#69c3a2", dark: "#69c3a2" },
  "--unique-21": { light: "#2db07b", dark: "#2db07b" },
  "--unique-22": { light: "#00b5b8", dark: "#00b5b8" },
  "--unique-23": { light: "#46a3b4", dark: "#46a3b4" },
  "--unique-24": { light: "#58c5a2", dark: "#58c5a2" },
  "--unique-25": { light: "#29b98b", dark: "#29b98b" },
  "--unique-26": { light: "#f4f76d", dark: "#f4f76d" },
  "--unique-27": { light: "#dbd41e", dark: "#dbd41e" },
  "--unique-28": { light: "#fc8a29", dark: "#fc8a29" },
  "--unique-29": { light: "#ce4c9d", dark: "#ce4c9d" },
  "--unique-30": { light: "#ff57d8", dark: "#ff57d8" },
  "--unique-31": { light: "#a869f1", dark: "#a869f1" },
  "--unique-32": { light: "#9d4de2", dark: "#9d4de2" },
  "--unique-33": { light: "#ff99c3", dark: "#ff99c3" },
  "--unique-34": { light: "#d4bf98", dark: "#d4bf98" },
  "--unique-35": { light: "#a3e6b4", dark: "#a3e6b4" },
  "--unique-36": { light: "#c5d8ff", dark: "#c5d8ff" },
  "--unique-37": { light: "#91a9e9", dark: "#91a9e9" },
  "--unique-38": { light: "#ff865f", dark: "#ff865f" },
  "--unique-39": { light: "#9e6aff", dark: "#9e6aff" },
  "--unique-40": { light: "#6bb0ff", dark: "#6bb0ff" },
  "--unique-41": { light: "#f3a9b9", dark: "#f3a9b9" },
  "--unique-42": { light: "#65d7d1", dark: "#65d7d1" },
  "--unique-43": { light: "#f0b7d1", dark: "#f0b7d1" },
  "--unique-44": { light: "#ff8b3f", dark: "#ff8b3f" },
  "--unique-45": { light: "#8ccf75", dark: "#8ccf75" },
  "--unique-46": { light: "#4a7b65", dark: "#4a7b65" },
  "--unique-47": { light: "#e44b6b", dark: "#e44b6b" },
  "--unique-48": { light: "#9fb79f", dark: "#9fb79f" },
  "--unique-49": { light: "#8dbbff", dark: "#8dbbff" },
  "--unique-50": { light: "#90ccff", dark: "#90ccff" },
  "--unique-51": { light: "#5d80b2", dark: "#5d80b2" },
  "--unique-52": { light: "#6fd4b1", dark: "#6fd4b1" },
  "--unique-53": { light: "#f79b7d", dark: "#f79b7d" },
  "--unique-54": { light: "#5c77b2", dark: "#5c77b2" },
  "--unique-55": { light: "#8bb8ff", dark: "#8bb8ff" },
  "--unique-56": { light: "#f2d2a6", dark: "#f2d2a6" },
  "--unique-57": { light: "#70a8c7", dark: "#70a8c7" },
  "--unique-58": { light: "#9b6dd4", dark: "#9b6dd4" },
  "--unique-59": { light: "#76f4d2", dark: "#76f4d2" },
  "--unique-60": { light: "#ff4c4c", dark: "#ff4c4c" },
  "--unique-61": { light: "#8d77f1", dark: "#8d77f1" },
  "--unique-62": { light: "#4a92ec", dark: "#4a92ec" },
  "--unique-63": { light: "#fcb25a", dark: "#fcb25a" },
  "--unique-64": { light: "#f3a2c7", dark: "#f3a2c7" },
  "--unique-65": { light: "#ff547b", dark: "#ff547b" },
  "--unique-66": { light: "#6b9bf7", dark: "#6b9bf7" },
  "--unique-67": { light: "#d27f85", dark: "#d27f85" },
  "--unique-68": { light: "#b3f1a7", dark: "#b3f1a7" },
  "--unique-69": { light: "#c593e5", dark: "#c593e5" },
  "--unique-70": { light: "#e5a377", dark: "#e5a377" },
  "--unique-71": { light: "#b8b5ff", dark: "#b8b5ff" },
  "--unique-72": { light: "#93e4db", dark: "#93e4db" },
  "--unique-73": { light: "#ffb14b", dark: "#ffb14b" },
  "--unique-74": { light: "#e37799", dark: "#e37799" },
  "--unique-75": { light: "#4c92a0", dark: "#4c92a0" },
  "--unique-76": { light: "#9b98f3", dark: "#9b98f3" },
  "--unique-77": { light: "#d4b1d3", dark: "#d4b1d3" },
  "--unique-78": { light: "#b7a2f7", dark: "#b7a2f7" },
  "--unique-79": { light: "#f2797d", dark: "#f2797d" },
  "--unique-80": { light: "#f6c24f", dark: "#f6c24f" },
  "--unique-81": { light: "#4a7f99", dark: "#4a7f99" },
  "--unique-82": { light: "#e8758d", dark: "#e8758d" },
  "--unique-83": { light: "#ffd283", dark: "#ffd283" },
  "--unique-84": { light: "#7a7c7f", dark: "#7a7c7f" },
  "--unique-85": { light: "#9f7da8", dark: "#9f7da8" },
  "--unique-86": { light: "#90e35f", dark: "#90e35f" },
  "--unique-87": { light: "#e68e6d", dark: "#e68e6d" },
  "--unique-88": { light: "#d97b55", dark: "#d97b55" },
  "--unique-89": { light: "#94a6f2", dark: "#94a6f2" },
  "--unique-90": { light: "#7b91f6", dark: "#7b91f6" },
  "--unique-91": { light: "#efb8bc", dark: "#efb8bc" },
  "--unique-92": { light: "#c7b5f0", dark: "#c7b5f0" },
  "--unique-93": { light: "#bb9bf6", dark: "#bb9bf6" },
  "--unique-94": { light: "#e4a4f1", dark: "#e4a4f1" },
  "--unique-95": { light: "#fbd446", dark: "#fbd446" },
  "--unique-96": { light: "#ffca0d", dark: "#ffca0d" },
  "--unique-97": { light: "#fbb32d", dark: "#fbb32d" },
  "--unique-98": { light: "#abd20f", dark: "#abd20f" },
  "--unique-99": { light: "#a9df8b", dark: "#a9df8b" },
  "--unique-100": { light: "#2d9f83", dark: "#2d9f83" },
  "--unique-101": { light: "#074b12", dark: "#074b12" },
  "--unique-102": { light: "#59c5be", dark: "#59c5be" },
  "--unique-103": { light: "#43badb", dark: "#43badb" },
  "--unique-104": { light: "#59abf2", dark: "#59abf2" },
  "--unique-105": { light: "#799cf0", dark: "#799cf0" },
  "--unique-106": { light: "#477bb8", dark: "#477bb8" },
  "--unique-107": { light: "#d878e7", dark: "#d878e7" },
  "--unique-108": { light: "#9783e8", dark: "#9783e8" },
  "--unique-109": { light: "#8656b3", dark: "#8656b3" },
  "--unique-110": { light: "#534171", dark: "#534171" },
};

export const THEME_COLOR = {
  ...COMMON_THEME,
  ...SHADOW_THEME,
  ...PALETTE_THEME,
  ...PRIMARY_THEME,
  ...GRAYSCALE_BG_THEME,
  ...GRAYSCALE_TEXT_THEME,
  ...SECONDARY_THEME,
  ...SYSTEM_THEME,
  ...ACCENT_THEME,
  ...INTERACTION_THEME,
  ...UNIQUE_COLOR,
};
